import _ from 'lodash';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import ExpandableProfileCard from 'components/customer/profile/expandable_profile_card';
import ExternalLink from 'components/lib/external_link';
import { GeneralTransaction } from './transaction_group';
import { OrderTransactionDef, TransactionDefType } from 'models/configuration/transaction_def';
import ProfileCardDef, { ProfileCardType } from 'models/configuration/profile_card_def';
import { Action } from 'models/configuration/action';

export const OrderAttributesPropTypes = PropTypes.shape({
  currencyCode: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  sku: PropTypes.string,
  total: PropTypes.string,
  note: PropTypes.string,
  actions: PropTypes.arrayOf(Action),
});

export default function OrderTransactions({ isLoading, transactionDef, transactions, onExpand, profileCardDef }) {
  const orders = _.orderBy(transactions, [order => moment(order.attributes.createdAt).valueOf()], ['desc']);
  const numOrders = orders.length;

  return (
    <ExpandableProfileCard
      title={_.get(profileCardDef, 'label') || `${numOrders} Order${numOrders === 1 ? '' : 's'}`}
      isEmpty={!numOrders}
      isLoading={isLoading}
      limit={3}
    >
      {_.map(orders, (order, idx) => (
        <GeneralTransaction
          isExpanded={idx === 0}
          attributes={order.attributes}
          headerAttributes={_.omit(order.attributes, 'products')}
          key={order.attributes.orderNumber}
          transactionDef={transactionDef}
          onExpand={onExpand}
          summaryRenderer={summaryRenderer}
          headerRenderer={expandedOrderHeader}
        />
      ))}
    </ExpandableProfileCard>
  );

  function expandedOrderHeader() {
    return () => null;
  }

  function summaryRenderer(attributes) {
    return <OrderSummary attributes={attributes} transactionDef={transactionDef} />;
  }
}

OrderTransactions.propTypes = {
  isLoading: PropTypes.bool,
  onExpand: PropTypes.func,
  profileCardDef: PropTypes.instanceOf(ProfileCardDef),
  transactionDef: PropTypes.instanceOf(OrderTransactionDef),
  transactions: PropTypes.arrayOf(PropTypes.shape({ attributes: OrderAttributesPropTypes })),
};

export function OrderSummary({ attributes }) {
  const { status, orderNumber, orderLink, orderTotal, createdAt } = attributes;
  const createdAtVal = moment(createdAt).isValid() ? moment(createdAt).format('M/D/YYYY') : 'N/A';

  return (
    <div className="orderTransaction-summary">
      <ExternalLink
        url={orderLink}
        text={orderNumber || ''}
        className="orderTransaction-orderLink"
        type={ProfileCardType.TRANSACTIONS}
        subType={TransactionDefType.ORDER}
        attrName="orderLink"
      />
      <div className="orderTransaction-createdAt" title="Created at">
        {createdAtVal}
      </div>
      {renderStatusOrTotal()}
    </div>
  );

  function renderStatusOrTotal() {
    if (orderTotal) {
      return (
        <div className="orderTransaction-status" title="Order total">
          {orderTotal}
        </div>
      );
    } else {
      return (
        <div className="orderTransaction-status" title="Order status">
          {status}
        </div>
      );
    }
  }
}

OrderSummary.propTypes = {
  attributes: OrderAttributesPropTypes,
  transactionDef: PropTypes.instanceOf(OrderTransactionDef),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/transactions/order_transactions.jsx